/* eslint-disable camelcase */
import React, { useContext, useEffect, useState, useCallback } from 'react';
import clsx from 'clsx';

import { ChipGroup } from 'components';
import { useSnackbar } from 'hooks';

import { FeatureContext } from 'components/AccessResolvers/featureContext';
import { LicensesContext, actionTypes } from '../../licensesContext';

const NoUsers = () => {
  return (
    <div className="Caption-Emphasis m-create-team__user-chips__no-users">
      Nobody is assigned to this license right now. Add someone below.
    </div>
  );
};

export const UserChips = () => {
  const {
    licensesState: {
      editLicenseAssignment: {
        license_definition: { license_type } = {},
        licenseDefinition: { licenseType } = {},
        license_count,
        licenseCount,
        number_of_licenses_assigned,
        numberOfLicensesAssigned,
      },
      selectedUserList,
    },
    dispatch,
  } = useContext(LicensesContext);
  const {
    featureState: { authV3Enabled },
  } = useContext(FeatureContext);

  const [showOpened, setShowOpened] = useState(false);
  const [chips, setChips] = useState([]);

  const setSnackbar = useSnackbar(true);

  const licenseUsageText = `${
    number_of_licenses_assigned ?? numberOfLicensesAssigned
  } out of ${license_count || licenseCount} licenses used`;
  const licenseUsageTextColor =
    number_of_licenses_assigned >= license_count ||
    numberOfLicensesAssigned >= licenseCount
      ? 'm-create-team__user-chips__license-usage-text-warning-color'
      : 'm-create-team__user-chips__license-usage-text-color';

  useEffect(() => {
    setChips(selectedUserList);
  }, [selectedUserList]);

  const handleShowOpened = useCallback(() => {
    setShowOpened(!showOpened);
  }, [showOpened]);

  const handleRemove = (email, user) => {
    const { profiles, nextivaUuid } = user;

    if ((license_type || licenseType) === 'BASE') {
      setSnackbar({
        message: `Base licenses can't be removed here. Navigate to Users > Edit Profile to remove licenses.`,
        severity: 'error',
      });

      return;
    }

    dispatch({
      type: actionTypes.SET_BULK_REQUEST_BODY,
      authV3Enabled,
      bulkRequestBody: authV3Enabled
        ? {
            userUuid: nextivaUuid,
            action: 'REMOVE',
          }
        : { profile_id: `${profiles[0].id}`, action: 'REMOVE' },
    });

    dispatch({
      type: actionTypes.SET_USER_CHECKED_STATE,
      email,
      authV3Enabled,
    });
  };

  // TODO: refactor UserChips to pass data instead of creating one
  const chipList = chips.map((user) => {
    return {
      key: user.email,
      label: `${user.first_name || user.firstName} ${
        user.last_name || user.lastName
      }`,

      onDelete: handleRemove,
      data: user,
    };
  });

  return (
    <div
      className="m-create-team__user-chips"
      data-testid="PlatformAdminUI-Licensing-UserChips-Body"
    >
      <div className="m-create-team__user-chips__license-usage-text-container">
        <div
          className="Caption-Emphasis m-create-team__user-chips__title"
          data-testid="PlatformAdminUI-Licensing-UserChips-Title"
        >
          Users currently using this license
        </div>
        <div
          className={clsx(
            'm-create-team__user-chips__license-usage-text',
            licenseUsageTextColor,
          )}
          data-testid="PlatformAdminUI-Licensing-UserChips-LicenseUsageText"
        >
          {licenseUsageText}
        </div>
      </div>
      {chips.length === 0 && <NoUsers />}
      {chips.length > 0 && (
        <ChipGroup
          chipList={chipList}
          open={showOpened}
          showClick={handleShowOpened}
          className="editTeam"
          type="bulkLicensing"
        />
      )}
    </div>
  );
};
